/*
 * HomeFit shapes — top-down line drawings for the room planner.
 * Works out the shape from the product name + type, e.g.
 *   "Isola Sofa 1.5 Seater W/Left Arm"        → one arm, on the left
 *   "Volta Sofa Single Chaise Right Arm"      → chaise module, arm on the right
 *   "Linate Sofa 2L-Shape Chaise On Right"    → sofa with chaise on the right
 *   "Dahlia Sofa 2.8L + Corner + 2R (Set)"    → L-shaped sofa, return on the right
 *   "Isola Sofa Corner Unit", ottomans, benches, armchairs, beds
 * Drawn in the piece's own frame (back at the top, front at the bottom) and rotated with it.
 * Left/right follows HANDING: "facing" = as seen standing in front of the sofa (Commune default),
 * "seated" = as seen sitting on it. Set per section in the theme editor.
 */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var cache = {};
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function node(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    parent.appendChild(n);
    return n;
  }
  function numMatch(t, re) { var m = t.match(re); return m ? parseFloat(m[1]) : null; }
  function sideIn(str) { return /left|\bl\b/.test(str) ? 'left' : /right|\br\b/.test(str) ? 'right' : null; }

  /** Work out what to draw from the product name and type. Returns null for plain blocks. */
  function parse(name, type) {
    var t = String(name || '').toLowerCase().replace(/\s+/g, ' ');
    var ty = String(type || '').toLowerCase().trim();
    var sofaish = ty === 'sofas' || ty === 'sofa add-ons' || /sofa|seater|chaise|sectional|corner unit|recliner|loveseat/.test(t);

    if (ty === 'beds' || ty === 'bed' || ty === 'mattresses' || (!sofaish && /\bbed\b|bed frame/.test(t))) return { kind: 'bed' };
    if (/ottoman|pouf|stool|bench/.test(t) || ty === 'ottomans' || ty === 'benches' || ty === 'stools & barstools') {
      return (sofaish || ty === 'ottomans' || ty === 'benches' || ty === 'stools & barstools') ? { kind: 'ottoman' } : null;
    }
    if (ty === 'accent chairs' || /armchair|lounge chair|accent chair/.test(t)) {
      if (/armless/.test(t)) return { kind: 'sofa', left: false, right: false, seats: 1 };
      return { kind: 'sofa', left: true, right: true, seats: 1 };
    }
    if (!sofaish) return null;

    var seats = numMatch(t, /(\d+(?:\.\d+)?)\s*-?\s*seat/) || numMatch(t, /(\d+(?:\.\d+)?)\s*s\b/) || numMatch(t, /(\d+(?:\.\d+)?)\s*[lr]?\s*-?\s*shape/) || numMatch(t, /(\d+(?:\.\d+)?)\s*[lr]\s*\+/);

    // L-shaped set: "2.8L + Corner + 2R"  (first run's arm letter tells where the corner sits)
    if (/corner/.test(t) && /\+/.test(t)) {
      var m = t.match(/(\d+(?:\.\d+)?)\s*([lr])\b[^+]*\+\s*corner/);
      var s2 = numMatch(t, /corner\s*\+\s*(\d+(?:\.\d+)?)/);
      var firstArm = m ? m[2] : 'l';
      return { kind: 'lcorner', ret: firstArm === 'l' ? 'right' : 'left', seats: m ? parseFloat(m[1]) : seats, seats2: s2 };
    }
    // single corner module
    if (/corner/.test(t)) return { kind: 'corner' };

    // chaise
    if (/chaise/.test(t)) {
      var cs = t.match(/chaise\s*(?:on\s*)?(?:the\s*)?(left|right)/) || t.match(/(left|right)\s*(?:arm\s*)?chaise/);
      var armSide = sideIn((t.match(/(left|right)\s*arm/) || [])[0] || '');
      var isSet = !/single chaise/.test(t) && (/set|\+|l-?shape|seater/.test(t));
      if (isSet) return { kind: 'chaiseSet', chaise: cs ? cs[1] : 'right', seats: seats };
      return { kind: 'chaise', arm: armSide || (cs ? cs[1] : null) };
    }

    // arms
    if (/armless/.test(t)) return { kind: 'sofa', left: false, right: false, seats: seats, curved: /curve/.test(t) };
    var left = /left arm|w\/\s*left|with left|\blaf\b|l\/h arm/.test(t);
    var right = /right arm|w\/\s*right|with right|\braf\b|r\/h arm/.test(t);
    if (left || right) return { kind: 'sofa', left: left, right: right, seats: seats };
    return { kind: 'sofa', left: true, right: true, seats: seats };
  }

  function mirrorSide(s) { return s === 'left' ? 'right' : s === 'right' ? 'left' : s; }
  function applyHanding(p, handing) {
    if (!p || handing !== 'seated') return p;
    var q = Object.assign({}, p);
    if (q.kind === 'sofa') { var l = q.left; q.left = q.right; q.right = l; }
    if (q.kind === 'chaise') q.arm = mirrorSide(q.arm);
    if (q.kind === 'chaiseSet') q.chaise = mirrorSide(q.chaise);
    if (q.kind === 'lcorner') q.ret = mirrorSide(q.ret);
    return q;
  }

  function cushionCount(seats, span) {
    var n = seats ? Math.max(1, Math.floor(seats)) : Math.max(1, Math.round(span / 68));
    while (span / n > 105) n++;
    while (n > 1 && span / n < 40) n--;
    return n;
  }
  function cushionsX(g, x0, x1, y0, y1, n) {
    var gap = 2, cw = (x1 - x0) / n;
    for (var i = 0; i < n; i++) node('rect', { class: 'hf-cu', x: x0 + i * cw + gap / 2, y: y0 + gap / 2, width: Math.max(1, cw - gap), height: Math.max(1, y1 - y0 - gap), rx: 4 }, g);
  }
  function cushionsY(g, x0, x1, y0, y1, n) {
    var gap = 2, ch = (y1 - y0) / n;
    for (var i = 0; i < n; i++) node('rect', { class: 'hf-cu', x: x0 + gap / 2, y: y0 + i * ch + gap / 2, width: Math.max(1, x1 - x0 - gap), height: Math.max(1, ch - gap), rx: 4 }, g);
  }
  function up(g, x, y, w, h) { if (w > 0.5 && h > 0.5) node('rect', { class: 'hf-up', x: x, y: y, width: w, height: h, rx: 4 }, g); }

  /** Draw piece `it` (w × d, rot) into group `g` at footprint `f`. Returns true if a drawing was made. */
  function draw(g, it, f, opts) {
    var key = (it.name || '') + '|' + (it.ptype || '');
    if (!(key in cache)) cache[key] = parse(it.name, it.ptype);
    var p = applyHanding(cache[key], opts && opts.handing);
    if (!p || it.round) return false;

    var W = it.w, D = it.d;
    var root = node('g', { transform: 'translate(' + (f.x + f.w / 2) + ' ' + (f.y + f.h / 2) + ') rotate(' + (it.rot || 0) + ') translate(' + (-W / 2) + ' ' + (-D / 2) + ')' }, g);
    var bt = clamp(D * 0.2, 12, 24);           // back thickness
    var aw = clamp(W * 0.12, 10, 22);          // arm width
    var outline = 'M0,0 H' + W + ' V' + D + ' H0 Z';
    var mirror = false, body;

    if (p.kind === 'chaiseSet' || p.kind === 'lcorner') {
      mirror = (p.kind === 'chaiseSet' && p.chaise === 'left') || (p.kind === 'lcorner' && p.ret === 'left');
    }
    var c = mirror ? node('g', { transform: 'translate(' + W + ' 0) scale(-1 1)' }, root) : root;

    if (p.kind === 'chaiseSet') {
      // canonical: chaise on the right
      var dm = clamp(D * 0.6, 75, 110), cw = clamp(W * 0.36, 75, 120);
      if (dm > D - 20) dm = D;
      outline = 'M0,0 H' + W + ' V' + D + ' H' + (W - cw) + ' V' + dm + ' H0 Z';
      body = node('path', { class: 'hf-body', d: outline }, c);
      up(c, 0, 0, W, bt);
      up(c, 0, 0, aw, dm);
      up(c, W - aw, 0, aw, D);
      var x1 = W - cw;
      cushionsX(c, aw, x1, bt, dm, cushionCount(p.seats ? Math.max(1, p.seats - 1) : null, x1 - aw));
      cushionsY(c, x1, W - aw, bt, D, 1);
    } else if (p.kind === 'lcorner') {
      // canonical: main run across the back, return down the right side
      var dr = clamp(Math.min(W, D) * 0.4, 75, 110);
      outline = 'M0,0 H' + W + ' V' + D + ' H' + (W - dr) + ' V' + dr + ' H0 Z';
      body = node('path', { class: 'hf-body', d: outline }, c);
      up(c, 0, 0, W, bt);
      up(c, W - bt, 0, bt, D);
      up(c, 0, 0, aw, dr);
      up(c, W - dr, D - aw, dr - bt, aw);
      var cx = W - dr;
      cushionsX(c, aw, cx, bt, dr, cushionCount(p.seats, cx - aw));
      node('rect', { class: 'hf-cu', x: cx + 1, y: bt + 1, width: dr - bt - 2, height: dr - bt - 2, rx: 4 }, c);
      cushionsY(c, cx, W - bt, dr, D - aw, cushionCount(p.seats2, D - aw - dr));
    } else if (p.kind === 'corner') {
      body = node('path', { class: 'hf-body', d: outline }, c);
      up(c, 0, 0, W, bt);
      up(c, W - bt, 0, bt, D);
      node('rect', { class: 'hf-cu', x: 1, y: bt + 1, width: W - bt - 2, height: D - bt - 2, rx: 4 }, c);
    } else if (p.kind === 'chaise') {
      body = node('path', { class: 'hf-body', d: outline }, c);
      up(c, 0, 0, W, bt);
      var l0 = 0, r0 = W;
      if (p.arm === 'left') { up(c, 0, 0, aw, D); l0 = aw; }
      if (p.arm === 'right') { up(c, W - aw, 0, aw, D); r0 = W - aw; }
      var split = bt + clamp((D - bt) * 0.45, 45, 70);
      node('rect', { class: 'hf-cu', x: l0 + 1, y: bt + 1, width: r0 - l0 - 2, height: split - bt - 2, rx: 4 }, c);
      node('rect', { class: 'hf-cu', x: l0 + 1, y: split + 1, width: r0 - l0 - 2, height: D - split - 2, rx: 4 }, c);
    } else if (p.kind === 'sofa') {
      body = node('path', { class: 'hf-body', d: outline }, c);
      up(c, 0, 0, W, bt);
      var a0 = 0, a1 = W;
      if (p.left) { up(c, 0, 0, aw, D); a0 = aw; }
      if (p.right) { up(c, W - aw, 0, aw, D); a1 = W - aw; }
      cushionsX(c, a0, a1, bt, D, cushionCount(p.seats, a1 - a0));
    } else if (p.kind === 'ottoman') {
      body = node('path', { class: 'hf-body', d: outline }, c);
      node('rect', { class: 'hf-cu', x: 3, y: 3, width: Math.max(1, W - 6), height: Math.max(1, D - 6), rx: 6 }, c);
    } else if (p.kind === 'bed') {
      body = node('path', { class: 'hf-body', d: outline }, c);
      var hb = clamp(D * 0.04, 5, 10);
      up(c, 0, 0, W, hb);
      var py = hb + 6, ph = clamp(D * 0.1, 14, 24), pw = W > 130 ? (W - 30) / 2 : W - 20;
      node('rect', { class: 'hf-cu', x: 10, y: py, width: pw, height: ph, rx: 6 }, c);
      if (W > 130) node('rect', { class: 'hf-cu', x: 20 + pw, y: py, width: pw, height: ph, rx: 6 }, c);
      var fold = py + ph + clamp(D * 0.12, 15, 30);
      node('line', { class: 'hf-ln', x1: 4, y1: fold, x2: W - 4, y2: fold }, c);
    } else {
      return false;
    }
    return true;
  }

  window.HomeFitShapes = { draw: draw, parse: parse };
})();